import React, { useState, useRef, useEffect } from 'react';
import ArrowIcon from "../../../assets/ArrowDownBlue.svg";
import "./TagsContainer.css"
import TaskTeg from '../TaskTag';
import { loadavg } from 'os';

interface Tag {
  id: number;
  name: string;
  color: string;
}

interface TagsContainerProps {
  tags: Tag[];
  onLoadingChange?: (loading: boolean) => void;
}

const TagsContainer: React.FC<TagsContainerProps> = ({
  tags,
  onLoadingChange
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [visibleTags, setVisibleTags] = useState<Tag[]>([]);
  const [hiddenCount, setHiddenCount] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const calculateVisibleTags = () => {
      if (!containerRef.current || tags.length === 0) {
        if (onLoadingChange) {
          onLoadingChange(false);
        }
        return
      };
      const container = containerRef.current;
      const containerWidth = container.offsetWidth;
      const tempContainer = document.createElement('div');
      tempContainer.style.visibility = 'hidden';
      tempContainer.style.position = 'absolute';
      tempContainer.style.display = 'flex';
      tempContainer.style.gap = '4px';
      document.body.appendChild(tempContainer);

      

      // Создаем временные элементы для измерения
      tags.forEach(tag => {
        const tagElement = document.createElement('span');
        tagElement.textContent = tag.name;
        tagElement.style.padding = '1px 5px';
        tagElement.style.borderRadius = '4px';
        tagElement.style.fontSize = "14px";
        tagElement.style.background = tag.color;
        tagElement.style.color = 'white';
        tagElement.style.whiteSpace = 'nowrap';
        tempContainer.appendChild(tagElement);
      });

      // Измеряем ширину всех элементов
      const children = Array.from(tempContainer.children);
      let totalWidth = 30;
      let lastVisibleIndex = -1;

      for (let i = 0; i < tags.length; i++) {
        totalWidth += children[i].scrollWidth + 4;
        if (totalWidth > containerWidth) {
          break;
        }
        lastVisibleIndex = i;
      }

      document.body.removeChild(tempContainer);

      if (lastVisibleIndex === tags.length - 1) {
        setVisibleTags(tags);
        setHiddenCount(0);
      } else if (lastVisibleIndex >= 0) {
        setVisibleTags(tags.slice(0, lastVisibleIndex + 1));
        setHiddenCount(tags.length - (lastVisibleIndex + 1));
      } else {
        setVisibleTags([]);
        setHiddenCount(tags.length);
      }

      if (onLoadingChange) {
        onLoadingChange(false);
      }
    };

    calculateVisibleTags();
    window.addEventListener('resize', calculateVisibleTags);

    return () => {
      window.removeEventListener('resize', calculateVisibleTags);
    };
  }, [tags, isExpanded]);

  if (isExpanded) {
    return (
      <div
        className='tags-container'
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div
          ref={containerRef}
          className='tags-container-full'
          style={{
            width: '100%',
            flexWrap: "wrap",
          }}
        >
          {tags.map((tag, index) => (
            <TaskTeg key={`task-teg-${index}`} name={tag.name} color={tag?.color ? tag.color : ""} />
          ))}
        </div>
        <button
          onClick={() => setIsExpanded(false)}
          className='tag-button-show'
        >
          <img src={ArrowIcon} alt="arrow-icon" />
        </button>
      </div>
    );
  }

  return (
    <div
      className='tags-container'
      style={{
        width: "100%",
        display: "flex",
      }}
    >
      <div
        ref={containerRef}
        className='tags-container-full'
        style={{
          width: '100%',
          flexWrap: "nowrap",
        }}
      >
        {visibleTags.map((tag, index) => (
          <TaskTeg key={`task-teg-${index}`} name={tag.name} color={tag?.color ? tag.color : ""} />
        ))}
      </div>
      {hiddenCount > 0 && (
        <button
          onClick={() => setIsExpanded(true)}
          className='tag-button-show'
        >
          +{hiddenCount}
        </button>
      )}
    </div>
  );
};

export default TagsContainer;